
import { defineComponent } from "vue";

export default defineComponent({
  name: "SideBar",
  emits: ["onChangeTheme"],
  data() {
    return {
      isDarkTheme: false,
    };
  },
  computed: {
    buttonText() {
      if (this.isDarkTheme) {
        return "Desativar modo escuro";
      }
      return "Ativar modo escuro";
    },
  },
  methods: {
    changeTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      this.$emit("onChangeTheme", this.isDarkTheme);
    },
  },
});
